export const CONFIG_TEMPLATES_DATA = {
  enableAiEvents: {
    id: 'enableAiEvents',
    name: 'AI Events',
    description: 'Enable/disable AI detection events',
    iconKey: 'Eye',
    color: 'purple',
    category: 'ai'
  },
  driverAssist: {
    id: 'driverAssist',
    name: 'Driver Assist',
    description: 'Turn signal sensors and CAN settings',
    iconKey: 'ArrowLeftRight',
    color: 'blue',
    category: 'driver'
  },
  speedSettings: {
    id: 'speedSettings',
    name: 'Speed & CAN',
    description: 'CAN bus rate and speed source',
    iconKey: 'Gauge',
    color: 'cyan',
    category: 'vehicle'
  },
  remoteWakeup: {
    id: 'remoteWakeup',
    name: 'Remote Wakeup',
    description: 'Sleep mode and remote wake settings',
    iconKey: 'Power',
    color: 'green',
    category: 'power'
  },
  privacyMode: {
    id: 'privacyMode',
    name: 'Privacy Mode',
    description: 'Audio/video privacy settings',
    iconKey: 'Shield',
    color: 'red',
    category: 'privacy'
  },
  soundVolume: {
    id: 'soundVolume',
    name: 'Sound Volume',
    description: 'Device speaker volume',
    iconKey: 'Volume2',
    color: 'orange',
    category: 'audio'
  },
  videoSettings: {
    id: 'videoSettings',
    name: 'Video Settings',
    description: 'Recording quality and resolution',
    iconKey: 'Video',
    color: 'pink',
    category: 'video'
  },
  serverSettings: {
    id: 'serverSettings',
    name: 'Server Settings',
    description: 'Cloud server connection',
    iconKey: 'Server',
    color: 'slate',
    category: 'network'
  },
  userPassword: {
    id: 'userPassword',
    name: 'User Password',
    description: 'Device login credentials',
    iconKey: 'Lock',
    color: 'rose',
    category: 'security'
  },
  m1nLargeModel: {
    id: 'm1nLargeModel',
    name: 'M1N Large Model',
    description: 'M1N AI model settings',
    iconKey: 'Zap',
    color: 'violet',
    category: 'ai'
  },
  customJson: {
    id: 'customJson',
    name: 'Custom JSON',
    description: 'Paste or edit any MDVR configuration payload',
    iconKey: 'FileJson',
    color: 'slate',
    category: 'custom'
  }
};

export const DMS_ALARMS_DATA = [
  { index: 0, label: 'Fatigue', iconKey: 'Eye', description: 'Driver fatigue detection' },
  { index: 1, label: 'No Driver', iconKey: 'UserX', description: 'No driver detected' },
  { index: 2, label: 'Phone Usage', iconKey: 'Phone', description: 'Phone usage while driving' },
  { index: 3, label: 'Smoking', iconKey: 'Cigarette', description: 'Smoking detection' },
  { index: 4, label: 'Distraction', iconKey: 'Brain', description: 'Driver distraction' },
  { index: 10, label: 'Yawning', iconKey: 'SunDim', description: 'Yawning detection' },
  { index: 16, label: 'Seatbelt', iconKey: 'CircleDot', description: 'Seatbelt not fastened' },
  { index: 22, label: 'IR Block', iconKey: 'EyeOff', description: 'Infrared camera blocked' }
];

export const ADAS_ALARMS_DATA = [
  { index: 5, label: 'LDW', iconKey: 'Car', description: 'Lane Departure Warning' },
  { index: 6, label: 'FCW', iconKey: 'ShieldAlert', description: 'Forward Collision Warning' },
  { index: 7, label: 'Overspeed', iconKey: 'Gauge', description: 'Overspeed alarm' },
  { index: 9, label: 'HMW', iconKey: 'Clock', description: 'Headway Monitoring Warning' },
  { index: 11, label: 'PCW', iconKey: 'Zap', description: 'Pedestrian Collision Warning' },
  { index: 31, label: 'Rolling Stop', iconKey: 'AlertTriangle', description: 'Rolling stop violation' }
];
